export default __webpack_public_path__ + "static/media/Armwraps of Fiendish Invocation.fec03fe7.jpg";